module.exports = __webpack_public_path__ + "img/denmark-tuberculosis-female.c4f61eed.png";